// status płatności, dostaw
// @ts-nocheck

import React, { FC, useMemo } from 'react';
import classnames from 'classnames';
import { Truck, Clock, CheckCircle, PauseCircle, HourglassSplit, XCircle } from 'react-bootstrap-icons';

import styles from 'theme/components/controls/Status/Status.module.scss';

// typ danych wejściowych
interface IProps {
  icon: string;
  message: string;
  color?: string;
}

const Status: FC<IProps> = ({ icon, message, color }) => {
  // Mapowanie statusów na ikony i kolory zgodnie z designem
  const { statusColor, statusIcon } = useMemo(() => {
    const messageLower = message?.toLowerCase() || '';
    
    if (messageLower.includes('oczekuje na akceptację') || messageLower.includes('waiting for acceptance')) {
      return {
        statusIcon: HourglassSplit,
        statusColor: '#E88C00'
      };
    }

    if (messageLower.includes('odrzucone') || messageLower.includes('rejected')) {
      return {
        statusIcon: XCircle,
        statusColor: '#E84545'
      };
    }

    if (messageLower.includes('w dostawie') || messageLower.includes('in delivery')) {
      return {
        statusIcon: Truck,
        statusColor: '#81C784' // jasny zielony
      };
    }
    
    if (messageLower.includes('wstrzymane') || messageLower.includes('paused') || messageLower.includes('stopped')) {
      return {
        statusIcon: PauseCircle,
        statusColor: '#FFB74D' // jasny pomarańczowy
      };
    }
    
    if (messageLower.includes('w realizacji') || messageLower.includes('in progress') || messageLower.includes('processing')) {
      return {
        statusIcon: Clock,
        statusColor: '#81C784' // jasny zielony
      };
    }
    
    if (messageLower.includes('zakończone') || messageLower.includes('completed') || messageLower.includes('finished')) {
      return {
        statusIcon: CheckCircle,
        statusColor: '#64B5F6' // jasny niebieski
      };
    }
    
    // Domyślnie użyj wartości z API
    return {
      statusIcon: null,
      statusColor: color
    };
  }, [icon, message, color]);

  const IconComponent = statusIcon;
  const finalColor = statusColor || color;

  return (
    <div
      className={classnames(styles.componentWrapper, 'StylePath-Components-Controls-Status')}
      style={{ 
        borderColor: finalColor || undefined, 
        color: finalColor || undefined,
        border: finalColor ? `1px solid ${finalColor}` : undefined
      }}>
      {IconComponent ? <IconComponent /> : (icon ? <img src={icon} alt="" /> : null)}
      <span className={styles.message}>{message}</span>
    </div>
  );
};

export default Status;

